// Auto-generated TypeScript enum from PHP enum

export type PageRenderProfile = 'print' | 'standard';

export const PageRenderProfile = {
  Print: 'print' as const,
  Standard: 'standard' as const,
} as const;

export const PageRenderProfileUtils = {
  values: Object.values(PageRenderProfile),
  keys: Object.keys(PageRenderProfile) as Array<keyof typeof PageRenderProfile>,
  entries: Object.entries(PageRenderProfile) as Array<[keyof typeof PageRenderProfile, PageRenderProfile]>,
  isValid: (value: any): value is PageRenderProfile => Object.values(PageRenderProfile).includes(value),
  fromKey: (key: keyof typeof PageRenderProfile): PageRenderProfile => PageRenderProfile[key],
};

